import { render } from "./DialogSaleLimit.vue?vue&type=template&id=4093c049"
import script from "./DialogSaleLimit.vue?vue&type=script&lang=js"
export * from "./DialogSaleLimit.vue?vue&type=script&lang=js"
script.render = render

export default script